module.exports = __webpack_public_path__ + "static/feedback@2x-b15677306541e00a74c6b56a7d44c7d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/agencies-industry-pages/feedback@2x.jpg
// module id = 2529
// module chunks = 281026976107462